module.exports = __webpack_public_path__ + "media/images/lb/359-17bfe8081470bb48a33be047d26037dd.svg";